import React, { useEffect, useRef } from 'react';
import './Home.css';
import { projects } from '../../Data/projectsData';

import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import transition from '../../transition';
import CV from '../../Images/Bohdan_Asauliuk_CV.pdf';
import Recommendation from '../../Images/recommendation-letter.pdf';

const Home = () => {
  const homeRef = useRef(null);
  const sectionsRef = useRef([]);

  // Add sections to ref array
  const addToSectionsRef = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  useEffect(() => {
    const homeElement = homeRef.current;
    let isScrolling = false;
    let lastScrollTime = 0;
    const scrollCooldown = 500; // ms to wait between scroll events

    // Get the current visible section index
    const getCurrentSectionIndex = () => {
      const sections = sectionsRef.current;
      for (let i = 0; i < sections.length; i++) {
        const rect = sections[i].getBoundingClientRect();
        // Consider a section visible if its top is within viewport or slightly above
        if (rect.top <= 100 && rect.bottom >= 100) {
          return i;
        }
      }
      return 0; // Default to first section if none found
    };

    const scrollToSection = (index) => {
      const sections = sectionsRef.current;
      if (sections[index]) {
        isScrolling = true;

        // Use requestAnimationFrame for smoother transitions
        requestAnimationFrame(() => {
          sections[index].scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });

        // Reset isScrolling after animation completes
        setTimeout(() => {
          isScrolling = false;
        }, scrollCooldown);
      }
    };

    const handleWheel = (e) => {
      const now = Date.now();

      // If we're already scrolling or haven't passed the cooldown, prevent default behavior
      if (isScrolling || now - lastScrollTime < scrollCooldown) {
        e.preventDefault();
        return;
      }

      lastScrollTime = now;

      const delta = e.deltaY;
      const currentSectionIndex = getCurrentSectionIndex();

      let targetIndex = currentSectionIndex;
      if (delta > 0 && currentSectionIndex < sectionsRef.current.length - 1) {
        // Scroll down
        targetIndex = currentSectionIndex + 1;
      } else if (delta < 0 && currentSectionIndex > 0) {
        // Scroll up
        targetIndex = currentSectionIndex - 1;
      }

      if (targetIndex !== currentSectionIndex) {
        scrollToSection(targetIndex);
        e.preventDefault();
      }
    };

    // Handle touch events for mobile
    let touchStartY = 0;
    let touchStartTime = 0;
    let initialScrollTop = 0;

    const handleTouchStart = (e) => {
      if (isScrolling) return;

      touchStartY = e.touches[0].clientY;
      touchStartTime = Date.now();
      initialScrollTop = homeElement.scrollTop;
    };

    const handleTouchMove = (e) => {
      if (isScrolling) {
        e.preventDefault();
        return;
      }

      const touchEndY = e.touches[0].clientY;
      const delta = touchStartY - touchEndY;
      const currentSectionIndex = getCurrentSectionIndex();
      const touchTime = Date.now() - touchStartTime;

      // Check if browser is already handling scroll naturally
      const currentScrollTop = homeElement.scrollTop;
      const hasScrollChanged = Math.abs(currentScrollTop - initialScrollTop) > 5;

      // For short/slow movements, let the browser handle it naturally
      if (hasScrollChanged || Math.abs(delta) < 50 || touchTime > 300) return;

      let targetIndex = currentSectionIndex;
      if (delta > 0 && currentSectionIndex < sectionsRef.current.length - 1) {
        // Swipe up (scroll down)
        targetIndex = currentSectionIndex + 1;
      } else if (delta < 0 && currentSectionIndex > 0) {
        // Swipe down (scroll up)
        targetIndex = currentSectionIndex - 1;
      }

      if (targetIndex !== currentSectionIndex) {
        scrollToSection(targetIndex);
        e.preventDefault();
      }
    };

    if (homeElement) {
      homeElement.addEventListener('wheel', handleWheel, { passive: false });
      homeElement.addEventListener('touchstart', handleTouchStart, { passive: true });
      homeElement.addEventListener('touchmove', handleTouchMove, { passive: false });
    }

    return () => {
      if (homeElement) {
        homeElement.removeEventListener('wheel', handleWheel);
        homeElement.removeEventListener('touchstart', handleTouchStart);
        homeElement.removeEventListener('touchmove', handleTouchMove);
      }
    };
  }, []);

  return (
    <motion.div className="Home" ref={homeRef}>
      {/* <div className="bg"></div> */}
      <section className="hero scroll-container" ref={addToSectionsRef}>
        <div className="headers">
          <div className="header header-1">
            <h1>
              <motion.div
                initial={{
                  top: '7rem',
                  transition: {
                    duration: 1,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.25,
                  },
                }}
                animate={{
                  top: 0,
                  transition: {
                    duration: 1.5,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.25,
                  },
                }}
                className="h1"
              >
                Bohdan Asauliuk
              </motion.div>
              <div className="h1-revealer"></div>
            </h1>
            <h1>
              <motion.div
                className="h1"
                initial={{
                  top: '7rem',
                  transition: {
                    duration: 1,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.1,
                  },
                }}
                animate={{
                  top: 0,
                  transition: {
                    duration: 1.5,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.1,
                  },
                }}
              >
                &nbsp;mobile&nbsp;&&nbsp;
              </motion.div>
              <div className="h1-revealer"></div>
            </h1>
            <h1>
              <motion.div
                className="h1"
                initial={{
                  top: '7rem',
                  transition: {
                    duration: 1,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.1,
                  },
                }}
                animate={{
                  top: 0,
                  transition: {
                    duration: 1.5,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.1,
                  },
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;web
              </motion.div>
              <div className="h1-revealer"></div>
            </h1>
            <h1>
              <motion.div
                className="h1"
                initial={{
                  top: '7rem',
                  transition: {
                    duration: 1,
                    ease: [0.83, 0, 0.17, 1],
                    delay: 0.05,
                  },
                }}
                animate={{
                  top: 0,
                  transition: {
                    duration: 1.5,
                    ease: [0.83, 0, 0.17, 1],
                    delay: 0.05,
                  },
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;dev.
              </motion.div>
              <div className="h1-revealer"></div>
            </h1>
          </div>
          <div className="header header-2">
            <h1>
              <motion.div
                className="h1"
                initial={{
                  top: '7rem',
                  transition: {
                    duration: 1,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.25,
                  },
                }}
                animate={{
                  top: 0,
                  transition: {
                    duration: 1.5,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.25,
                  },
                }}
              >
                personal
              </motion.div>
              <div className="h1-revealer"></div>
            </h1>
            <h1>
              <motion.div
                className="h1"
                initial={{
                  top: '7rem',
                  transition: {
                    duration: 1,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.1,
                  },
                }}
                animate={{
                  top: 0,
                  transition: {
                    duration: 1.5,
                    ease: [0.83, 0, 0.17, 1],
                    delay: -0.1,
                  },
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;page
              </motion.div>
              <div className="h1-revealer"></div>
            </h1>
          </div>
        </div>
      </section>

      <div className="projects-nav scroll-container" ref={addToSectionsRef}>
        <div className="projects-nav-container">
          <h1 className="projects-title">Projects</h1>
          {projects.map((project, index) => (
            <div key={project.id} className="project-item">
              <Link to={project.link}>
                <div className="project-link">
                  <div className="project-l">
                    <div className="project-link-img">
                      <img src={project.image} alt={project.name} />
                    </div>
                    <div className="project-info">
                      <div className="project-name">
                        <h2>{project.name}</h2>
                      </div>
                      {project.mainTech && (
                        <div className="project-tech-pills">
                          {project.mainTech.map((tech, i) => (
                            <span key={i} className="tech-pill">
                              {tech}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="project-date">
                    <p>{project.type}</p>
                    <p>/{project.year}</p>
                  </div>
                  <div className="project-dir">
                    <p>&#8599;</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <section className="about scroll-container" ref={addToSectionsRef}>
        <div className="about-container">
          <div className="about-col">
            <p>(about me)</p>
            <p>
              Experienced React and React Native developer with over 2 years of development experience. Skilled in
              creating responsive UIs and delivering high-quality, innovative applications. My expertise spans front-end
              technologies like React, and React Native with a basic understanding of back-end technologies including
              Node.js and databases. I'm passionate about clean coding, continuous learning, and contributing to dynamic
              teams. My goal is to leverage my skills in mobile and web development to create impactful, user-centric
              applications.
            </p>
          </div>
          <div className="about-col">
            <div className="socials">
              <a href="mailto:bohdan.asauliuk@gmail.com">email &#8599;</a>
              <a
                href="https://www.linkedin.com/in/bohdan-asauliuk-653994147/"
                target="_blank"
                rel="noopener noreferrer"
              >
                linkedin &#8599;
              </a>
              <a href="https://github.com/Larnex" target="_blank" rel="noopener noreferrer">
                github &#8599;
              </a>

              <a href={CV} target="_blank" rel="noopener noreferrer">
                CV &#8599;
              </a>
              <a href={Recommendation} target="_blank" rel="noopener noreferrer">
                recommendation letter &#8599;
              </a>
            </div>
          </div>
        </div>
      </section>

      <div className="footer">
        <motion.div
          className="divider"
          initial={{
            width: 0,
            transition: {
              duration: 1,
              ease: [0.83, 0, 0.17, 1],
            },
          }}
          animate={{
            width: '100%',
            transition: {
              duration: 1.5,
              ease: [0.83, 0, 0.17, 1],
            },
          }}
        ></motion.div>
        <motion.div
          className="footer-content"
          initial={{
            y: 200,
            opacity: 0,
            transition: { duration: 1, ease: [0.83, 0, 0.17, 1], delay: 2 },
          }}
          animate={{
            y: 0,
            opacity: 1,
            transition: {
              duration: 2,
              ease: [0.83, 0, 0.17, 1],
            },
          }}
        >
          <ol className="footer-content-list">
            <li className="footer-content-list-col">
              <span>2+ years React & React Native dev</span>
            </li>
            <li className="footer-content-list-col">
              <span>prev web & mobile dev at Omnystate</span>
            </li>
            <li className="footer-content-list-col">
              <span>TypeScript, Redux expert</span>
            </li>
          </ol>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default transition(Home);
